<template>
  <l-modal
    :showing="showing"
    text="Observing Capabilities"
    icon="edit"
    color="bg-orange-500"
    @close="close"
  >
    <div class="w-full text-xs" v-if="editObj.id">
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Id</b>
          <br />
          <l-input
            placeholder="Enter unique Id"
            v-model="editObj.id"
            inputClass="text-2xs"
            :disabled="!this.isnew"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Begin Position</b>
          <br />
          <l-input
            placeholder="YYYY-MM-DDTHH:mm:ss+hh:00"
            v-model="editObj.begin_position"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>End Position</b>
          <br />
          <l-input
            placeholder="YYYY-MM-DDTHH:mm:ss+hh:00 (optional)"
            v-model="editObj.end_position"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Process Type</b>
          <br />
          <l-select
            v-model="editObj.process_type"
            class="text-xs"
            :data="processtypevalues"
            :multiple="false"
          >
            <l-option
              v-for="i in processtypevalues"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Result Nature</b>
          <br />
          <l-select
            v-model="editObj.result_nature"
            class="text-xs"
            :data="resultnaturevalues"
            :multiple="false"
          >
            <l-option
              v-for="i in resultnaturevalues"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>

        <div class="w-1/2">
          <b>Pollutant</b>
          <br />
          <l-select
            v-model="editObj.pollutant"
            class="text-xs"
            :data="pollutants"
            :multiple="false"
          >
            <l-option
              v-for="i in pollutants"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Concentration</b>
          <br />
          <l-select
            v-model="editObj.concentration"
            class="text-xs"
            :data="concentrations"
            :multiple="false"
          >
            <l-option
              v-for="i in concentrations"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Time step</b>
          <br />
          <l-select v-model="editObj.timestep" class="text-xs" :data="timesteps" :multiple="false">
            <l-option
              v-for="i in timesteps"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Sampling Point ID</b>
          <br />
          <l-select
            v-model="editObj.sampling_point_id"
            class="text-xs"
            :data="samplingpoints"
            :multiple="false"
          >
            <l-option
              v-for="i in samplingpoints"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Process ID</b>
          <br />
          <l-select
            v-model="editObj.process_id"
            class="text-xs"
            :data="processes"
            :multiple="false"
          >
            <l-option
              v-for="i in processes"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Sample ID</b>
          <br />
          <l-select v-model="editObj.sample_id" class="text-xs" :data="samples" :multiple="false">
            <l-option
              v-for="i in samples"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>

      <div class="flex w-full justify-between">
        <l-button type="success" @click="onSave">Save changes</l-button>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";

export default {
  name: "LLEdit",
  props: [
    "showing",
    "observing_capabilities",
    "processtypevalues",
    "resultnaturevalues",
    "pollutants",
    "concentrations",
    "timesteps",
    "samplingpoints",
    "processes",
    "samples",
    "selected",
    "isnew"
  ],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption
  },
  computed: {
    editObj: function() {
      return Object.assign({}, this.selected);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSave() {
      // debugger;
      const pt = this.processtypevalues.find(
        r => r.value == this.editObj.process_type
      );
      this.editObj.process_type_name = pt.label;

      const rn = this.resultnaturevalues.find(
        r => r.value == this.editObj.result_nature
      );
      this.editObj.result_nature_name = rn.label;

      const p = this.pollutants.find(r => r.value == this.editObj.pollutant);
      this.editObj.pollutant_name = p.label;

      const c = this.concentrations.find(
        r => r.value == this.editObj.concentration
      );
      this.editObj.concentration_name = c.label;

      const t = this.timesteps.find(r => r.value == this.editObj.timestep);
      this.editObj.timestep_name = t.label;

      const sp = this.samplingpoints.find(
        r => r.value == this.editObj.sampling_point_id
      );
      this.editObj.sampling_point_id = sp.label;

      const pr = this.processes.find(r => r.value == this.editObj.process_id);
      this.editObj.process_id = pr.label;

      const s = this.samples.find(r => r.value == this.editObj.sample_id);
      this.editObj.sample_id = s.label;

      this.$emit("save", this.editObj);
      this.close();
    }
  }
};
</script>